<mat-dialog-content>
  <div class="quick_search">
    <mat-card class="quick_search_form_card">
      <div class="quick_search_header">
        <p>Quick search</p>
        <a class="material-icons" mat-dialog-close>close</a>
      </div>

    @if (warningMsg) {
    <div class="search_warn">
      <app-success-or-warning-popup [popupType]="'warning'" [displayText]="warningMsg" (message)="showWarningMsg()"></app-success-or-warning-popup>
    </div>
    }

    @if (quickSearchForm) {
    <form [formGroup]="quickSearchForm" class="quick_search_form_container">
      <div class="quick_search_inner_form">

        <div class="row campus_form padding_top_24 filter_search_center">
          <!-- Entity Type Dropdown -->
          <div class="input_sec" [ngClass]="{'input_error':submitFlag && quickSearchForm?.get('entityType')?.errors?.required}">
            <div class="input_label">Entity type<span>*</span></div>
            <mat-form-field appearance="fill" class="quick-search-field">
              <mat-select formControlName="entityType" (selectionChange)="changeEntityType($event.value)" placeholder="Select entity type">
                @for (entity of entityTypes; track entity) {
                <mat-option [value]="entity">{{entity}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (submitFlag && quickSearchForm?.get('entityType')?.errors?.required) {
            <div class="error_msg"><p>Please select the entity type</p></div>
            }
          </div>
        </div>
        
        @if(!quickSearchForm?.get('entityType').value){
          <!-- search filter content -->
          <div class="search_filter">
            <div class="search_icon_content">
              <img [src]="imageConstants.searchIcon" alt="search icon">
              <p class="search_filter_content_title">Start Your Search</p>
            </div>
            <p class="search_filter_content_para">Select an entity type to proceed with your search.</p>
          </div>
        }

        @if(quickSearchForm?.get('idType')) {
          <!-- ID Type Dropdown -->
          <div class="input_sec campus_form filter_id_type padding_top_24" [ngClass]="{'input_error':submitFlag && quickSearchForm?.get('idType')?.errors?.required}">
            <div class="input_label">ID type<span>*</span></div>
            <mat-radio-group formControlName="idType" (change)="changeIdType()" class="search_id_radio">
              @for (idType of idTypes; track idType) {
              <mat-radio-button [value]="idType.type" class="search_radio_type" [disabled]="idType.isDisabled" [ngClass]="{'search_radio_type_disabled': idType.isDisabled}">{{ idType.type }}</mat-radio-button>
              }
            </mat-radio-group>
          </div>

          <div class="row campus_form padding_top_24 filter_search_center">
          <!-- ID -->
          @if(quickSearchForm?.get('entityId')) {
          <div roleAccessControl class="input_sec" [ngClass]="{'input_error':submitFlag && quickSearchForm?.get('entityId')?.errors?.required}">
            <div class="input_label">{{quickSearchForm?.get('idType')?.value}}<span>*</span></div>
            <mat-form-field appearance="fill" class="quick-search-field">
              <input matInput type="text" formControlName="entityId" #idValue (input)="fieldValueRestriction($event)" (keydown)="commonFn.restrictSpace($event, idValue.value)" />
            </mat-form-field>
            @if(submitFlag && quickSearchForm?.get('entityId')?.errors?.required) {
            <div class="error_msg"><p>Please enter the {{quickSearchForm?.get('idType')?.value?.toLowerCase()}}</p></div>
            }
          </div>
          }
        </div>
        }

        <!-- Academic Year dropdown if course instance is selected -->
        @if(quickSearchForm?.get('academicYear')) {
        <div class="row campus_form padding_top_24 filter_search_center">
          <div class="input_sec" [ngClass]="{'input_error':submitFlag && quickSearchForm?.get('academicYear')?.errors?.required}">
            <div class="input_label">Academic year</div>
            <mat-form-field appearance="fill" class="quick-search-field">
              <mat-select formControlName="academicYear" placeholder="Select academic year">
                <mat-option [value]="">Select academic year</mat-option>
                @for (year of academicYears; track year) {
                <mat-option [value]="year">{{ year }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        }

      </div>
    </form>
    }
    
    <div class=" quick_search_cta">
      <button type="button" mat-stroked-button class="btn_group" (click)="searchData()">SEARCH</button>
    </div>
  </mat-card>

</div>

</mat-dialog-content>